// client/src/lib/cableRouteApi.js
// Calls our backend cable-route engine. Same-origin in prod; the CRA dev
// server proxies /api to :3001.
export async function fetchCableRoute(olt, building, options = {}) {
  try {
    const res = await fetch('/api/cable-route', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ olt, building, options }),
    });
    if (!res.ok) {
      const e = await res.json().catch(() => ({}));
      return { data: null, error: e.error || `HTTP ${res.status}` };
    }
    return { data: await res.json(), error: null };
  } catch (err) {
    return { data: null, error: err.message };
  }
}
